<template>
  <v-container>
    <v-expansion-panel light>
      <v-expansion-panel-content
        v-for="group in groups"
        :key="group.id"
      >
        <div slot="header">{{ group.title }}</div>
        <v-card
          v-for="id in group.distractions"
          :key="id"
        >
          <v-card-text>
            <template v-if="distractions[id]">
              <span v-html="distractions[id].body" />
            </template>
            <template v-else>
              Loading...
            </template>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    groups: [],
    distractions: []
  }),
  mounted: function () {
    var _this = this
    this.axios.get('/distractions/types')
      .then(function (res) {
        // Make sure that our types are sorted by their index value
        _this.groups = res.data.sort(function (a, b) {
          if (a.index < b.index) {
            return -1
          } else if (a.index > b.index) {
            return 1
          } else {
            return 0
          }
        })

        // We want to populate data for our distractions and not just ID numbers
        for (var i in _this.groups) {
          let group = _this.groups[i]
          for (var j in group.distractions) {
            let id = group.distractions[j]
            _this.axios.get('/distractions/' + id)
              .then(function (res) {
                // Sanity check before assigning the value
                if (res.data.length > 0) {
                  let distraction = res.data[0]
                  _this.distractions[distraction.id] = distraction

                  // All we want to do is update _this.distractions, but changing
                  // properties in this context doesn't propagate a rendering update,
                  // so we force the creation of a new object instead.
                  // TODO: Find a better way to force the rendering update.
                  _this.distractions = _this.distractions.slice()
                } else {
                  throw new RangeError('No distraction information returned')
                }
              })
              .catch(_this.$root.apiErrorHandler())
          }
        }
      })
      .catch(this.$root.apiErrorHandler())
  }
}
</script>
